import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'local_modules/valuelink'
import cx from 'classnames'

import s from './CheckBox.scss'


class CheckBox extends Component {

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    label: PropTypes.any,
    valueLink: PropTypes.object,
  }

  static defaultProps = {
    className: '',
    checked: false,
    disabled: false,
  }

  render() {
    const { label, children, className, valueLink, readOnly, id, onClick } = this.props

    const checkboxClassName = cx(s.checkbox, {
      [s.disabled]: readOnly,
    })

    let inputProps = {
      className: s.input,
      type: 'checkbox',
      disabled: readOnly,
      readOnly,
      // checked: valueLink.value,
    }

    return (
      <label
        className={cx(s.root, className)}
        id={id}
        onClick={(event) => {
          event.preventDefault()
          event.stopPropagation()

          onClick(!valueLink.value)
        }}
      >
        {
          !!valueLink && (
            <Input
              valueLink={valueLink}
              {...inputProps}
            />
          )
        }
        <div className={checkboxClassName} />
        {
          Boolean(label) && (
            <span className={s.label}>{label}</span>
          )
        }
        {
          Boolean(children) && (
            <span className={s.label}>{children}</span>
          )
        }
      </label>
    )
  }
}


export default CheckBox
